// Some hardened / anti-fingerprinting browsers (and a few in-app webviews) keep
// `window`, `document` and `window.HTMLElement`, but expose `window.Blob` or
// `window.FileList` as `undefined`. react-hook-form's cloneObject() then runs
//
//   isWeb && (value instanceof Blob || value instanceof FileList)
//
// on every useForm({ defaultValues }) and throws
// "Right-hand side of 'instanceof' is not an object" during the first render —
// which blanked /admin/login for those clients (Sentry, prod).
//
// Restoring a harmless constructor keeps `instanceof` valid (it just answers
// false), so the form renders. Real browsers expose real constructors here and
// this is a no-op. Imported first from main.jsx, before anything renders.
if (typeof window !== 'undefined') {
  if (typeof window.FileList !== 'function') {
    window.FileList = class FileList {};
  }
  if (typeof window.Blob !== 'function') {
    window.Blob = class Blob {};
  }
}
